/** Horizontal alignment of a pivot measure's values. */
export enum PivotTextAlignEnum {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
}
